import { useCareerSkillDetailQuery } from 'core';

import { transformSkillDetail } from './transform';

/** ТЗ 0039, доводка UX — данные страницы одного навыка. */
export const useSkillDetail = (slug: string) => {
  const { data, loading } = useCareerSkillDetailQuery({
    variables: { slug },
    fetchPolicy: 'cache-and-network',
    skip: !slug,
  });

  return { skill: transformSkillDetail(data), loading };
};
